import { startTransition, useCallback, useState } from 'react';

import { Button, DialogContentText } from '@mui/material';

import { Modal } from '@components/modal';

import { useApp } from '@system/app';

export const ConfirmDialog = () => {
  const gState = useApp();
  const { set, use } = gState.confirmDialog;
  const $dialog = use();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = useCallback(() => {
    startTransition(() => {
      set(null);
      $dialog?.onClose?.();
    });
  }, [$dialog, set]);

  const handleConfirm = useCallback(async () => {
    if ($dialog?.onConfirm) {
      setIsLoading(true);
      try {
        const result = await $dialog.onConfirm();
        if (result) {
          handleClose();
        }
      } finally {
        setIsLoading(false);
      }
    }
  }, [$dialog, handleClose]);

  if (!$dialog) {
    return null;
  }

  return (
    <Modal
      open={true}
      onClose={!$dialog.disableCloseWithoutConfirm ? handleClose : undefined}
      title={$dialog?.title ?? 'Подтверждение'}
      dialogProps={$dialog.dialogProps}
      dialogButtons={
        <>
          {!$dialog.disableCloseWithoutConfirm && (
            <Button
              onClick={handleClose}
              {...$dialog?.buttonClose}
              color="primary"
              data-testid="doNotConfirmButton"
            >
              {$dialog.buttonClose?.text ?? 'Нет'}
            </Button>
          )}

          {$dialog?.onConfirm && (
            <Button
              onClick={handleConfirm}
              {...$dialog.buttonConfirm}
              color="informative"
              variant="contained"
              disabled={isLoading}
              data-testid="confirmButton"
            >
              {$dialog.buttonConfirm?.text ?? 'Да'}
            </Button>
          )}
        </>
      }
    >
      {typeof $dialog?.message === 'string' ? (
        <DialogContentText
          sx={{ whiteSpace: 'pre-line' }}
          data-testid="modal.message"
        >
          {$dialog?.message}
        </DialogContentText>
      ) : (
        $dialog?.message
      )}
    </Modal>
  );
};
